import { Component, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { FloatingMenuOption } from 'src/app/common/components/master-floating-menu/model/master-floating-model';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { ColumnFilter, RequestData, SearchSort } from 'src/app/common/models/request-data.model';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import { FilterListItemModel, SearchFilterComponent, SearchParam } from 'src/app/common/components/search-filter/search-filter.component';
import { Router, ActivatedRoute } from '@angular/router';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { MatSort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { VersionUpdaterService } from '../version-updater.service';
import { AreaModel } from '../../../system/area/model/area.model';
import { TerminalsByShopComponent } from '../terminals-by-shop/terminals-by-shop.component';
import { AssignShopsComponent } from '../assign-shops/assign-shops.component';



@Component({
  selector: 'app-version-updated-shop-list',
  templateUrl: './version-updated-shop-list.component.html',
  styleUrl: './version-updated-shop-list.component.scss',
  standalone: false
})
export class VersionUpdatedShopListComponent {
  versionList: any[] = [];
  selectedVersion: any = null; // Store the selected version data
  shopsList: any[] = []; // Store shops using the selected version
  originalShopsList: any[] = []; // Store original unfiltered shops data
  terminalsData: any[] = []; // Store terminals data for shops
  private isInitializing = true; // Flag to prevent multiple API calls during initialization

  showSearch: boolean = false;
  isLoading = true;
  loadingMessage: string = 'Loading shops data...'; // Loading message to display
  filter: FilterListItemModel[] = [
    {
      title: "Shop Code",
      column: "sh.code",
    },
    {
      title: "Shop Name",
      column: "sh.name",
    }
  ];
  topHeaderRow = ['shopGroup', 'terminalGroup'];
  displayedColumns = ['item', 'shopCode', 'shopName', 'totalTerminals', 'assignedTerminals', 'updatedTerminals'];
  pagingData = { length: 0, pageSize: 50, pageIndex: 0 };
  menuOption: FloatingMenuOption = {
    add: true,
    search: false,
    export: true,
    more: true
  }

  isHandset: boolean = false;
  searchColumFilter: SearchParam = {};
  columnSortData: SearchSort[] = [];
  selectedItem?: any;
  showSummaryPanel: boolean = false;
  selection = new SelectionModel<any>(true, []);
  dataSource = new MatTableDataSource(this.shopsList);
  IsDownloading: boolean = false;
  versionId: any;
  major: string = '';
  minor: string = '';
  patch: string = '';
  @Input() hideAdvanceSearch: boolean = false;


  constructor(private breakpointObserver: BreakpointObserver,
    private versionUpdaterService: VersionUpdaterService,
    public dialog: MatDialog,
    private snackBarService: SnackBarService,
    private router: Router,
    private stateManagerService: StateManagerService,
    private activatedRoute: ActivatedRoute,
  ) {

    this.versionList = [];
    this.shopsList = [];
    this.originalShopsList = [];
  }
  /**
    * initilaize the device model
    */
  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isHandset = true;
      } else {
        this.isHandset = false;
      }
    });

    // Get version parameter from route
    this.activatedRoute.params.subscribe(params => {
      this.versionId = params['updatedVersion']; // Get the version string directly
      if (this.versionId) {
        // Parse the version string to extract major, minor, patch if needed
        const versionParts = this.versionId.split('.');
        if (versionParts.length === 3) {
          this.major = versionParts[0];
          this.minor = versionParts[1];
          this.patch = versionParts[2];
        }
        this.loadVersionData();
      } else {
        // No version ID found - stop loading
        this.isLoading = false;
        this.loadingMessage = 'No version specified';
      }
    });

    // Loading state is managed by loadVersionData() method
    // Removed duplicate this.loadData() call
  }

  /**
   * Load specific version data using major, minor, and patch numbers
   */
  loadVersionData(): void {
    if (!this.versionId) {
      console.error('Version ID is required');
      return;
    }

    this.isLoading = true;
    this.loadingMessage = `Loading shops data for version ${this.versionId}...`;
    console.log(`Loading shops data for version: ${this.versionId}`);

    // Call API to get shops using this version
    this.versionUpdaterService.getShopsByVersion(this.versionId).subscribe({
      next: (response) => {
        if (response.status === 'SUCCESS') {
          // Process shops data - API already provides aggregated data per shop
          const rawShops = response.data.shops || [];

          // Transform API data to component format
          this.shopsList = rawShops
            .filter((shop: any) => {
              // Filter out shops where both code and name are null/empty
              return shop.code && shop.name;
            })
            .map((shop: any) => {
              // Calculate total terminals from station_list
              const stationList = (shop.station_list && typeof shop.station_list === 'string')
                ? shop.station_list.split(',').filter((s: string) => s.trim())
                : [];
              const totalTerminals = parseInt(shop.total_terminal_count || '0');
              const assignedTerminals = parseInt(shop.assigned_terminal_count || '0');
              const updatedTerminals = parseInt(shop.updated_trnl_count || '0');
              return {
                shop_id: shop.shop_id,
                shopCode: shop.code,
                shopName: shop.name,
                totalTerminals: totalTerminals,
                assignedTerminals: assignedTerminals,
                updatedTerminals: updatedTerminals,
                stationList: stationList,
                hasUpdates: updatedTerminals === assignedTerminals, // Show tick only when fully updated
                isFullyUpdated: updatedTerminals === assignedTerminals,
                updatePercentage: assignedTerminals > 0 ? Math.round((updatedTerminals / assignedTerminals) * 100) : 0
              };
            });

          // Store version details from the first shop (all have same version info)
          if (rawShops.length > 0) {
            const firstShop = rawShops[0];
            this.selectedVersion = {
              id: firstShop.id,
              major: firstShop.major,
              minor: firstShop.minor,
              patch: firstShop.patch,
              version: firstShop.path,
              description: firstShop.description,
              date: firstShop.date,
              critical: firstShop.is_critical === '1',
              isPublished: firstShop.is_published === '1',
              assignedShops: this.shopsList.length
            };
          }

          // Store original data for filtering
          this.originalShopsList = [...this.shopsList];

          // Update data source with processed shops list
          this.setDataSource(this.shopsList);
          this.pagingData.length = this.shopsList.length;

          // Select first row by default if shops exist
          if (this.shopsList.length > 0) {
            this.selectedItem = this.shopsList[0];
            this.showSummaryPanel = true;
          }

          console.log(`Loaded ${this.shopsList.length} shops for version ${this.versionId}`);

          if (this.shopsList.length === 0) {
            let snackBarData: SnackBarData = {
              message: 'No shops found for this version.',
              title: 'No Data',
              type: 'warn'
            };
            this.snackBarService.openSnackBar(snackBarData);
          }
        } else {
          // Handle API error response
          let snackBarData: SnackBarData = {
            message: response.message || 'Failed to load shops data',
            title: 'Error',
            type: 'error'
          };
          this.snackBarService.openSnackBar(snackBarData);
          console.error('API Error:', response.message);
        }
      },
      error: (error) => {
        // Handle network/connection errors
        let snackBarData: SnackBarData = {
          message: 'Failed to connect to server. Please try again.',
          title: 'Connection Error',
          type: 'error'
        };
        this.snackBarService.openSnackBar(snackBarData);
        console.error('Error loading shops for version:', error);
      },
      complete: () => {
        this.isLoading = false;
        this.isInitializing = false; // Mark initialization as complete
      }
    });
  }

  /** 
   * Set the datasource
   */
  setDataSource(dataList: any[]) {
    this.dataSource = new MatTableDataSource(dataList);
    this.dataSource.sort = this.sort;
  }
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;
  ngAfterViewInit(): void {

    this.loadPreviousState();
    // this.loadData();
  }

  /**
   * loads the previous state if exists
   */
  loadPreviousState(): void {

    var previousState = this.stateManagerService.getState(this.constructor.name);

    if (previousState !== undefined && this.searchFilter != undefined) {

      if (previousState.state.search.filters.scope) {
        this.pagingData.pageIndex = previousState.state.search.filters.scope.offset / previousState.state.search.filters.scope.limit;
        this.pagingData.pageSize = previousState.state.search.filters.scope.limit;
      }

      if (previousState.state.search.sort != undefined && previousState.state.search.sort.length > 0) {
        this.setSortColumn(previousState.state.search.sort[0].column, previousState.state.search.sort[0].order);
      }

      this.searchColumFilter = JSON.parse(JSON.stringify(previousState.state.search.filters));
      this.searchFilter.setSearchFilter(this.searchColumFilter, true);

    } else {
      this.setSortColumn('name', 'asc');
      // Remove loadData() call as it will be called by ngOnInit route params
    }

  }
  /**
   * Maps display column names to API column names
   * @param column 
   * @returns API column name
   */
  mapColumnToApiField(column: string): string {
    const columnMapping: { [key: string]: string } = {
      'shopCode': 'shopCode',
      'shopName': 'shopName',
      'totalTerminals': 'totalTerminals',
      'assignedTerminals': 'assignedTerminals',
      'updatedTerminals': 'updatedTerminals',
      'item': 'shop_id'
    };

    return columnMapping[column] || column;
  }

  /**
   * Sets the sort column
   * @param column 
   * @param direction 
   */
  setSortColumn(column: string, direction: SortDirection): void {
    this.columnSortData.length = 0;
    const apiColumn = this.mapColumnToApiField(column);
    this.columnSortData.push({ column: apiColumn, order: direction });
    this.sort.sort({
      id: column,
      start: direction,
      disableClear: false,
    });

    // this.sort.active=column;
    // this.sort.direction=direction;


  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.shopsList.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.shopsList);
  }

  /**
   * Create sort order
   * @returns sort criteria
   */
  getSort(): SearchSort[] {
    return this.columnSortData;
  }

  /**
     * Builds the request data to be send to API
     * @returns Request Data
     */
  buildRequestData(): RequestData {
    let searchParam = this.getSearchParam();
    let requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: searchParam.freeSearch,
          advSearch: searchParam.advSearch,
          scope: {
            limit: this.pagingData.pageSize,
            offset: (this.pagingData.pageIndex * this.pagingData.pageSize),
          }
        },
        sort: this.getSort(),
      }
    };
    console.log(requestData)
    return requestData;
  }

  /**
    * Set the column filter and reaload the daaa
    * @param columFilter 
    */

  onFilterApplied(columFilter: any): void {
    console.log('Filter applied:', columFilter);

    if (this.isInitializing) {
      return; // Don't make API calls during initialization
    }

    this.searchColumFilter = columFilter;
    this.loadVersionDataWithFilters();
  }

  /**
   * Load version data with server-side filtering
   */
  loadVersionDataWithFilters(): void {
    if (!this.versionId) {
      console.error('Version ID is required');
      return;
    }

    this.isLoading = true;
    this.loadingMessage = 'Searching shops...';
    console.log(`Loading filtered shops data for version: ${this.versionId}`, this.searchColumFilter);

    // Check if there are any filters or sorting applied
    const hasFilters = this.searchColumFilter && Object.keys(this.searchColumFilter).length > 0;
    const hasSorting = this.columnSortData && this.columnSortData.length > 0;

    // Use the buildRequestData function to create the payload in the correct format
    const requestData = this.buildRequestData();

    if (hasFilters || hasSorting) {
      // Use filtered API call with the properly formatted payload
      this.versionUpdaterService.getShopsByVersionWithFilters(this.versionId, requestData).subscribe({
        next: (response) => {
          this.processShopsResponse(response);
        },
        error: (error) => {
          this.handleLoadError(error);
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    } else {
      // Use regular API call when no filters or sorting
      this.versionUpdaterService.getShopsByVersion(this.versionId).subscribe({
        next: (response) => {
          this.processShopsResponse(response);
        },
        error: (error) => {
          this.handleLoadError(error);
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    }
  }

  /**
   * Process the shops response from API
   */
  private processShopsResponse(response: any): void {
    if (response.status === 'SUCCESS') {
      // Process shops data - API already provides aggregated data per shop
      const rawShops = response.data.shops || [];

      // Transform API data to component format
      this.shopsList = rawShops
        .filter((shop: any) => {
          // Filter out shops where both code and name are null/empty
          return shop.code && shop.name;
        })
        .map((shop: any) => {
          // Calculate total terminals from station_list
          const stationList = (shop.station_list && typeof shop.station_list === 'string')
            ? shop.station_list.split(',').filter((s: string) => s.trim())
            : [];
          const totalTerminals = parseInt(shop.total_terminal_count || '0');
          const assignedTerminals = parseInt(shop.assigned_terminal_count || '0');
          const updatedTerminals = parseInt(shop.updated_trnl_count || '0');
          return {
            shop_id: shop.shop_id,
            shopCode: shop.code,
            shopName: shop.name,
            totalTerminals: totalTerminals,
            assignedTerminals: assignedTerminals,
            updatedTerminals: updatedTerminals,
            stationList: stationList,
            hasUpdates: updatedTerminals === assignedTerminals, // Show tick only when fully updated
            isFullyUpdated: updatedTerminals === assignedTerminals,
            updatePercentage: assignedTerminals > 0 ? Math.round((updatedTerminals / assignedTerminals) * 100) : 0
          };
        });

      // Store version details from the first shop (all have same version info)
      if (rawShops.length > 0) {
        const firstShop = rawShops[0];
        this.selectedVersion = {
          id: firstShop.id,
          major: firstShop.major,
          minor: firstShop.minor,
          patch: firstShop.patch,
          version: firstShop.path,
          description: firstShop.description,
          date: firstShop.date,
          critical: firstShop.is_critical === '1',
          isPublished: firstShop.is_published === '1',
          assignedShops: this.shopsList.length
        };
      }

      // Store original data for filtering (only for initial load)
      if (!this.originalShopsList || this.originalShopsList.length === 0) {
        this.originalShopsList = [...this.shopsList];
      }

      // Update data source with processed shops list
      this.setDataSource(this.shopsList);
      this.pagingData.length = this.shopsList.length;

      // Select first row by default if shops exist
      if (this.shopsList.length > 0) {
        this.selectedItem = this.shopsList[0];
        this.showSummaryPanel = true;
      } else {
        this.selectedItem = null;
        this.showSummaryPanel = false;
      }

      console.log(`Loaded ${this.shopsList.length} shops for version ${this.versionId}`);

      if (this.shopsList.length === 0) {
        let snackBarData: SnackBarData = {
          message: 'No shops found matching the search criteria.',
          title: 'No Data',
          type: 'warn'
        };
        this.snackBarService.openSnackBar(snackBarData);
      }
    } else {
      // Handle API error response
      let snackBarData: SnackBarData = {
        message: response.message || 'Failed to load shops data',
        title: 'Error',
        type: 'error'
      };
      this.snackBarService.openSnackBar(snackBarData);
      console.error('API Error:', response.message);
    }
  }

  /**
   * Handle load errors
   */
  private handleLoadError(error: any): void {
    // Handle network/connection errors
    let snackBarData: SnackBarData = {
      message: 'Failed to connect to server. Please try again.',
      title: 'Connection Error',
      type: 'error'
    };
    this.snackBarService.openSnackBar(snackBarData);
    console.error('Error loading shops:', error);
  }

  navBack() {
    this.router.navigate(['utility/updater']);
  }
  /**
    * On delete menu item selected
    * Confirm the action and call the api to update
    */
  onDelete(areaInfo: AreaModel): void {
    // const areaId = areaInfo.id;
    // const message = `Are you sure, you want to delete ` + (areaInfo.name + "?");
    // const dialogData = new ConfirmDialogModel("Confirm Deletion", message);

    // const dialogRef = this.dialog.open(ConfirmDialogComponent, {
    //   maxWidth: "400px",
    //   data: dialogData
    // });

    // dialogRef.afterClosed().subscribe(dialogResult => {
    //   console.log(dialogResult);
    //   if (dialogResult) {
    //     this.versionUpdaterService.delete(areaInfo).subscribe({
    //       next: (response) => {
    //         if (response.status == 'SUCCESS') {
    //           // handle success
    //           let snckBarData: SnackBarData = {
    //             type: 'success',
    //             title: 'Saved',
    //             message: 'The record for ' + areaInfo.name + " has been deleted succesfully."
    //           }
    //           this.snackBarService.openSnackBar(snckBarData);
    //           this.loadData();
    //         } else {
    //           let snackBarData: SnackBarData = {
    //             message: response.message,
    //             title: 'Failed!!!',
    //             type: 'error'
    //           }
    //           this.snackBarService.openSnackBar(snackBarData);
    //         }
    //       },
    //       error: (error) => {
    //         let snackBarData: SnackBarData = {
    //           message: 'Failed to update. Connection to the server failed',
    //           title: 'Failed!!!',
    //           type: 'error'
    //         }
    //         this.snackBarService.openSnackBar(snackBarData);
    //       }
    //     });
    //   }
    // });
  }

  /**
   * loads the data based on the conditions
   */
  loadData(): void {
    // This component shows shops for a specific version
    // So we should load version data if we have a version ID
    if (this.versionId) {
      this.loadVersionData();
    } else {
      console.warn('No version ID available to load shops data');
      this.isLoading = false;
    }
  }

  /**
  * On areainfo selected
  * @param areaInfo 
  */
  onRowSelected(areaInfo: AreaModel): void {
    this.selectedItem = areaInfo;
    this.showSummaryPanel = true;
  }

  /**
    *  Set the sort param and relead the data
    * @param $event sort data
    * {"active": "email","direction": "asc"}
    *   
    */
  sortData($event: any): void {
    if (this.isInitializing) {
      return; // Don't make API calls during initialization
    }
    var sd = this.sort;
    this.columnSortData.length = 0;
    // Use the actual column name instead of mapping to API field
    this.columnSortData.push({ column: sd.active, order: sd.direction });
    this.loadVersionDataWithFilters();
  }
  /**
* Creates the column filter conditions based on search criteria
* @returns Filter condions for columns
*/
  getSearchParam(): SearchParam {

    return this.searchColumFilter;
  }

  /**
 * On edit the item
 * Show the edit dialog
 */
  onEdit(areaInfo: AreaModel): void {

    this.router.navigate(['area-edit', areaInfo.id]);
  }


  /**
   * 
   * @param event 
   * When page size is changed update paging data
   */
  onePageEvent(event: any): void {
    if (this.isInitializing) {
      return; // Don't make API calls during initialization
    }

    this.pagingData.pageIndex = event.pageIndex;
    this.pagingData.pageSize = event.pageSize;

    // For local pagination, we don't need to reload data
    // Just update the data source which handles pagination automatically
    this.setDataSource(this.shopsList);
  }

  /**
   * On Add clicked
   * Show the dialog to enter new area
   */
  addClicked(): void {

    // this.router.navigate(['area-edit', 0]);

  }

  exportClicked() {
    // this.isLoading = true;
    // let requestData = this.buildRequestData();
    // this.IsDownloading = true;
    // this.versionUpdaterService.downloadExcel(requestData)
    //   .subscribe({
    //     next: blob => {
    //       // Download logic
    //       this.IsDownloading = false;
    //       const url = window.URL.createObjectURL(blob);
    //       const link = document.createElement('a');
    //       link.href = url;
    //       link.download = 'region_list.csv'; // Adjust filename if needed
    //       link.click();
    //       window.URL.revokeObjectURL(url);
    //       this.isLoading = false;


    //     },
    //     error: error => {
    //       // Handle errors
    //       this.IsDownloading = false;
    //       let snackBarData: SnackBarData = {
    //         message: 'Failed to update. Connection to the server failed',
    //         title: 'Failed!!!',
    //         type: 'error'
    //       }
    //       this.snackBarService.openSnackBar(snackBarData);
    //       this.isLoading = false;
    //       // Display user-friendly error message to the user
    //     }
    //   }
    //   );
  }

  /**
   * Handle view shops action
   */
  onViewShops(version: any): void {
    // Navigate to shops and terminals view or open a dialog
    console.log('View shops for version:', version);
    // Implementation for viewing shops and terminals
  }

  onAssignedShop(version: any): void {

  }

  onShopsUpdate(version: any): void {

  }

  /**
   * Handle remove shop action
   */
  onRemoveShop(shop: any): void {
    const dialogData = new ConfirmDialogModel(
      'Confirm Removal',
      `Are you sure you want to remove shop ${shop.shopName} (${shop.shopCode}) from this version?`
    );

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: dialogData,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        // Implement shop removal logic here
        console.log('Remove shop:', shop);
        // You can add API call to remove the shop from the version
      }
    });
  }

  /**
   * Handle shop code click action - opens terminals dialog popup
   */
  onShopCodeClick(shop: any): void {
    console.log('Shop code clicked:', parseInt(shop.shop_id));

    // Open the terminals dialog
    const dialogRef = this.dialog.open(TerminalsByShopComponent, {
      data: {
        shopId: parseInt(shop.shop_id),
        shopCode: shop.shopCode,
        shopName: shop.shopName,
        versionId: this.versionId,
        version: this.versionId // Pass version string for payload
      },
      width: '600px',
      maxHeight: '80vh',
      panelClass: 'terminals-dialog'
    });

    // Handle dialog result
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.saved) {
        console.log('Terminals saved:', result.terminals);

        // Show success message
        let snackBarData: SnackBarData = {
          message: result.message || 'Terminals updated successfully',
          title: 'Success',
          type: 'success'
        };
        this.snackBarService.openSnackBar(snackBarData);

        // Reload the shop data to reflect changes
        this.loadVersionData();
      }
    });
  }

  /**
   * Handle deploy action
   */
  onDeploy(version: any): void {
    const dialogData = new ConfirmDialogModel(
      'Confirm Deployment',
      `Are you sure you want to deploy version ${version.version}?`
    );

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: dialogData,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.deployVersion(version);
      }
    });
  }

  /**
   * Deploy version
   */
  private deployVersion(version: any): void {
    this.isLoading = true;

    // Call deployment service
    const snackBarData: SnackBarData = {
      message: `Version ${version.version} deployment started successfully`,
      title: 'Deployment Started',
      type: 'success'
    };
    this.snackBarService.openSnackBar(snackBarData);
    this.isLoading = false;

    // Refresh data after deployment
    // this.loadData();
  }
}
